var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2093 15.9814V25.7062C27.2089 27.5158 26.645 29.2804 25.5959 30.755C24.5469 32.2296 23.0648 33.3409 21.3553 33.9347C19.6459 34.5285 17.7939 34.5752 16.0567 34.0685C14.3194 33.5618 12.7831 32.5267 11.661 31.1069C10.5388 29.6872 9.88659 27.9533 9.79484 26.146C9.70309 24.3387 10.1764 22.5477 11.1489 21.0216C12.1215 19.4955 13.5452 18.3102 15.2222 17.6301C16.8992 16.95 18.7463 16.809 20.5071 17.2266V21.4664C19.5887 21.0307 18.5536 20.9052 17.5576 21.1086C16.5616 21.312 15.6587 21.8334 14.9846 22.5943C14.3106 23.3553 13.9019 24.3145 13.8201 25.3277C13.7384 26.341 13.9879 27.3534 14.5311 28.2125C15.0744 29.0717 15.882 29.7312 16.8325 30.0917C17.7829 30.4523 18.8247 30.4944 19.8012 30.2117C20.7776 29.929 21.6358 29.3368 22.2466 28.5242C22.8574 27.7117 23.1877 26.7227 23.188 25.7062V7.61035H27.2093C27.2093 9.38788 27.9154 11.0926 29.1723 12.3495C30.4292 13.6064 32.1339 14.3125 33.9114 14.3125V18.3338C31.4744 18.337 29.1096 17.507 27.2093 15.9814Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.0c4a55bbb90a730d2e85dbd2327702ff.svg";
export { ForwardRef as ReactComponent };